<div class="row" style="margin-top: 10px;">
  <div class="col-md-3" *ngFor="let roommate of backendService.roommates">
    <div *ngIf="roommate.hasMail" class="alert alert-info text-center" style="font-size: 10px;">
      {{roommate.name}} has Mail.
    </div>
  </div>
</div>
